<template>
  <v-navigation-drawer
    :value="isOpenTemplateEditor"
    :permanent="isOpenTemplateEditor"
    :width="windowSize.x > 1280 ? 'calc(100vw - 101px)' : '100vw'"
    max-width="100vw"
    temporary
    fixed
    right
    color="grey lighten-3"
    style="z-index: 11;transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);"
  >
    <v-card min-height="100vh" color="grey lighten-3">
      <BaseToolbar
        ref="base-toolbar"
        @close="close"
        @save="submitData"
        @delete.prevent
        :loader-save="submitLoading"
        :title="title"
        :dark="false"
        type-title="icon"
        button-save
        color="white"
      >
        <div class="d-flex align-center mr-5">
          <v-btn
            ref="button-download-pdf"
            v-if="payload.id && payload.type === 'pdf'"
            :loading="downloadLoading"
            @click="getPDF()"
            color="white"
            class="primary--text"
            depressed
            tile
          >
            Descargar prueba
          </v-btn>
        </div>
      </BaseToolbar>
      <!------------------------------------------>
      <!-- VERSION 1 ----------------------------->
      <!------------------------------------------>
      <v-card-text
        v-if="editorVersion === 1"
        class="pa-0"
        style="overflow-y: hidden;height: calc(100vh - 64px)"
      >
        <v-row no-gutters>
          <v-col cols="12" sm="4">
            <v-card
              height="calc(100vh - 64px)"
              style="overflow-y:auto;"
              width="100%"
              outlined
              class="rounded-0"
            >
              <v-card-text>
                <v-container>
                  <v-row dense>
                    <v-col cols="12">
                      <v-select
                        ref="field-type"
                        v-model="payload.type"
                        :items="typeOptions"
                        v-validate="'required'"
                        :label="$t('templates.fields.type')"
                        :data-vv-name="$t('templates.fields.type')"
                        :error-messages="
                          errors.collect($t('templates.fields.type'))
                        "
                        outlined
                        dense
                        @input="typeChange"
                      />
                    </v-col>
                    <v-col
                      v-if="
                        !['landing', 'thank_you_page'].includes(payload.type)
                      "
                      cols="12"
                    >
                      <v-select
                        ref="field-template-event"
                        v-model="payload.template_event_id"
                        :items="eventOptions"
                        v-validate="'required'"
                        :label="$t('templates.fields.template_event')"
                        :data-vv-name="$t('templates.fields.template_event')"
                        :error-messages="
                          errors.collect($t('templates.fields.template_event'))
                        "
                        item-text="text"
                        item-value="id"
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        ref="field-name"
                        v-model="payload.name"
                        :label="$t('templates.fields.internal_name')"
                        v-validate="'required'"
                        :data-vv-name="$t('templates.fields.internal_name')"
                        :error-messages="
                          errors.collect($t('templates.fields.internal_name'))
                        "
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        ref="field-description"
                        v-model="payload.description"
                        v-validate="'required|max:255'"
                        :label="$t('templates.fields.description')"
                        :data-vv-name="$t('templates.fields.description')"
                        :error-messages="
                          errors.collect($t('templates.fields.description'))
                        "
                        counter="255"
                        outlined
                        dense
                        no-resize
                      />
                    </v-col>
                    <template
                      v-if="
                        ['landing', 'thank_you_page'].includes(payload.type)
                      "
                    >
                      <v-col cols="12">
                        <v-btn
                          @click="openCreateTranslationDialog()"
                          block
                          large
                          height="56px"
                          class="pa-4"
                          color="white"
                        >
                          <v-icon
                            v-text="
                              editorMode === 'edit'
                                ? 'translate'
                                : 'design_services'
                            "
                            class="mr-3"
                            color="primary"
                          />
                          <b
                            v-text="
                              editorMode === 'edit'
                                ? 'Agregar traducción'
                                : 'Editar diseño'
                            "
                            class="text-capitalize subtitle-2"
                          />
                          <v-spacer />
                          <v-icon
                            v-text="
                              editorMode === 'edit' ? 'add' : 'chevron_right'
                            "
                            class="ml-3"
                            color="primary"
                          />
                        </v-btn>
                      </v-col>
                      <v-col v-if="editorMode === 'edit'" cols="12">
                        <v-expansion-panels accordion>
                          <v-expansion-panel>
                            <v-expansion-panel-header
                              class="px-4 py-4 white--text"
                              color="primary"
                            >
                              <div>
                                <v-icon
                                  v-text="'design_services'"
                                  class="mr-3"
                                  color="white"
                                />
                                <b
                                  v-text="'Editar diseño'"
                                  class="text-capitalize subtitle-2"
                                />
                              </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="pa-0">
                              <v-divider />
                              <v-card
                                v-if="!translations.length"
                                max-height="400px"
                                class="overflow-y-auto"
                              >
                                <v-card-text class="pa-4">
                                  <v-row dense>
                                    <v-col>
                                      <v-img
                                        :src="
                                          require('@/assets/svg/box_empty.svg')
                                        "
                                        height="150"
                                        max-height="150px"
                                        aspect-ratio="1"
                                        contain
                                      />
                                      <div class="text-center">
                                        {{ $t('common.no_results_found') }}
                                      </div>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                              <v-list
                                v-else
                                dense
                                max-height="250px"
                                class="overflow-y-auto"
                              >
                                <template
                                  v-for="(translation, index) in translations"
                                >
                                  <v-list-item
                                    @click.stop="
                                      openTemplateDesign(translation)
                                    "
                                    :key="translation.id"
                                  >
                                    <v-icon v-text="'translate'" class="mr-3" />
                                    <v-list-item-content>
                                      <v-list-item-title
                                        v-text="translation.name"
                                        class="grey--text text--darken-1 font-weight-bold subtitle-2"
                                      />
                                    </v-list-item-content>
                                    <v-list-item-action
                                      class="flex-row align-center"
                                    >
                                      <v-btn
                                        @click.stop="
                                          translation.is_default
                                            ? false
                                            : setDefaultTranslation({
                                                template_id:
                                                  translation.template_id,
                                                translation_id: translation.id
                                              })
                                        "
                                        :color="
                                          translation.is_default
                                            ? 'amber darken-2'
                                            : ''
                                        "
                                        icon
                                      >
                                        <v-icon
                                          v-text="
                                            translation.is_default
                                              ? 'star'
                                              : 'star_border'
                                          "
                                        />
                                      </v-btn>
                                      <v-menu
                                        top
                                        left
                                        min-width="150px"
                                        style="z-index: 10;"
                                      >
                                        <template v-slot:activator="{ on }">
                                          <v-btn
                                            ref="item-menu-button-open"
                                            v-on="on"
                                            @click.stop
                                            icon
                                          >
                                            <v-icon>more_vert</v-icon>
                                          </v-btn>
                                        </template>
                                        <v-list>
                                          <v-list-item
                                            ref="item-button-open-editor"
                                            @click="
                                              openTemplateDesign(translation)
                                            "
                                          >
                                            <v-list-item-title>
                                              {{ $t('actions.edit') }}
                                            </v-list-item-title>
                                          </v-list-item>
                                          <v-list-item
                                            ref="item-button-open-remove"
                                            v-if="!translation.is_default"
                                            @click="
                                              openRemoveTranslationDialog(
                                                translation.id
                                              )
                                            "
                                          >
                                            <v-list-item-title>
                                              {{ $t('actions.delete') }}
                                            </v-list-item-title>
                                          </v-list-item>
                                        </v-list>
                                      </v-menu>
                                    </v-list-item-action>
                                  </v-list-item>
                                  <v-divider
                                    v-if="index < translations.length - 1"
                                    :key="index"
                                  />
                                </template>
                              </v-list>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-col>
                    </template>
                    <template v-else>
                      <v-col cols="12">
                        <v-btn
                          @click="openDesignEditor()"
                          block
                          large
                          height="56px"
                          class="pa-4"
                          color="primary"
                        >
                          <v-icon v-text="'design_services'" class="mr-3" />
                          <b
                            v-text="'Editar diseño'"
                            class="text-capitalize subtitle-2"
                          />
                          <v-spacer />
                          <v-icon v-text="'chevron_right'" class="ml-3" />
                        </v-btn>
                      </v-col>
                    </template>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" sm="8">
            <v-card
              height="calc(100vh - 64px)"
              style="overflow-y:auto;"
              outlined
              class="rounded-0"
              color="grey lighten-3"
            >
              <v-card-text
                v-if="
                  translationSelected &&
                    translationSelected.template &&
                    translationSelected.preview
                "
              >
                <v-row align="center" justify="center">
                  <v-col cols="12" md="10">
                    <v-img
                      :src="translationSelected.preview"
                      :lazy-src="translationSelected.preview"
                      contain
                      height="100%"
                      class="grey lighten-2"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          />
                        </v-row>
                      </template>
                    </v-img>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-alert
                v-else-if="editorMode === 'create'"
                :value="true"
                color="blue lighten-4"
                border="left"
                height="100%"
                width="100%"
                class="ma-0 d-flex align-center justify-center info--text"
              >
                <div
                  style="width: 100%;"
                  class="d-flex flex-column align-center justify-center"
                >
                  <v-icon v-text="'info'" color="info" size="50" />
                  <div
                    class="overline font-weight-bold text-center"
                    style="max-width: 160px;"
                  >
                    {{ $t('templates.edit.save_to_edit_design') }}
                  </div>
                </div>
              </v-alert>
              <v-alert
                v-else
                :value="true"
                :color="alert.color"
                :class="alert.class"
                border="left"
                height="100%"
                width="100%"
                class="ma-0 d-flex align-center justify-center"
              >
                <div
                  style="width: 100%;"
                  class="d-flex flex-column align-center justify-center"
                >
                  <v-icon
                    v-text="alert.icon"
                    :color="alert.iconColor"
                    size="50"
                  />
                  <div
                    v-text="alert.text"
                    class="overline font-weight-bold text-center"
                    style="max-width: 160px;"
                  />
                </div>
              </v-alert>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <!------------------------------------------>
      <!-- VERSION 2 ----------------------------->
      <!------------------------------------------>
      <v-card-text
        v-if="editorVersion === 2"
        class="pa-0"
        style="overflow-y: hidden;height: calc(100vh - 64px)"
      >
        <v-row no-gutters>
          <v-col cols="12" sm="4">
            <v-card
              height="calc(100vh - 64px)"
              style="overflow-y:auto;"
              width="100%"
              outlined
              class="rounded-0"
            >
              <v-card-text>
                <v-container>
                  <v-row dense>
                    <v-col cols="12">
                      <v-text-field
                        ref="field-name"
                        v-model="payload.name"
                        :label="$t('templates.fields.internal_name')"
                        v-validate="'required'"
                        :data-vv-name="$t('templates.fields.internal_name')"
                        :error-messages="
                          errors.collect($t('templates.fields.internal_name'))
                        "
                        outlined
                        dense
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        ref="field-description"
                        v-model="payload.description"
                        v-validate="'required|max:255'"
                        :label="$t('templates.fields.description')"
                        :data-vv-name="$t('templates.fields.description')"
                        :error-messages="
                          errors.collect($t('templates.fields.description'))
                        "
                        counter="255"
                        outlined
                        dense
                        no-resize
                      />
                    </v-col>
                    <v-col cols="12">
                      <v-btn
                        @click="openDesignEditor()"
                        block
                        large
                        height="56px"
                        class="pa-4"
                        color="primary"
                      >
                        <v-icon v-text="'design_services'" class="mr-3" />
                        <b
                          v-text="'Editar diseño'"
                          class="text-capitalize subtitle-2"
                        />
                        <v-spacer />
                        <v-icon v-text="'chevron_right'" class="ml-3" />
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog
      v-model="createTranslationDialog.display"
      persistent
      max-width="400px"
    >
      <v-card>
        <v-card-title class="pa-4 headline">
          {{ $t('templates.translations.create.title') }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-autocomplete
            v-model="createTranslationDialog.language_code"
            v-validate="'required'"
            :items="avaliableLanguages"
            :label="$tc('common.language', 1)"
            :error-messages="errors.collect($tc('common.language', 1))"
            :data-vv-name="$tc('common.language', 1)"
            required
            item-text="name"
            item-value="code"
            outlined
            dense
            class="mt-6"
          />
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn
            @click="closeCreateTranslationDialog()"
            :disabled="createTranslationDialog.loading"
            color="primary"
            outlined
          >
            {{ $t('actions.cancel') }}
          </v-btn>
          <v-btn
            @click="submitCreateTranslation()"
            :loading="createTranslationDialog.loading"
            color="primary"
            depressed
          >
            {{ $t('actions.accept') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <BaseConfirmDialog
      v-if="removeTranslationDialog.display"
      :title="$t('templates.translations.remove.title')"
      :description="$t('templates.translations.remove.description')"
      :accept-text="$t('actions.accept')"
      :cancel-text="$t('actions.cancel')"
      :submit-loading="removeTranslationDialog.loading"
      @close="closeRemoveTranslationDialog()"
      @proceed="submitRemoveTranslation()"
    />
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import BaseToolbar from '@/components/BaseToolbar.vue'
import BaseConfirmDialog from '@/components/BaseConfirmDialog.vue'
import templatesMixin from '@/mixins/templates'
import languages from '@/data/languages.json'

export default {
  name: 'TemplateEditor',
  components: {
    BaseToolbar,
    BaseConfirmDialog
  },
  mixins: [templatesMixin],
  props: {
    isGallery: {
      type: Boolean,
      default: false,
      required: false
    },
    isLayout: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data () {
    return {
      downloadLoading: false,
      submitLoading: false,
      createTranslationDialog: {
        display: false,
        loading: false,
        language_code: null
      },
      removeTranslationDialog: {
        display: false,
        loading: false,
        translation_id: null
      },
      typeOptions: [
        { text: 'Email', value: 'email' },
        { text: 'Landing', value: 'landing' },
        { text: 'PDF', value: 'pdf' },
        { text: 'Thank you page', value: 'thank_you_page' }
      ],
      payload: {
        type: null,
        version: null,
        template_event_id: null,
        name: '',
        description: '',
        json_config: null,
        template: '',
        status: 'active'
      },
      translationSelectedId: null
    }
  },
  computed: {
    ...mapState({ languages: state => state.locales }),
    ...mapGetters({
      windowSize: 'windowSize',
      template: 'templates/template',
      editorMode: 'templates/editorMode',
      editorVersion: 'templates/editorVersion',
      isOpenTemplateEditor: 'templates/isOpenTemplateEditor'
    }),
    translations () {
      if (
        this.editorMode === 'edit' &&
        this.template &&
        this.template.translations
      ) {
        return this.template.translations.map(translation => {
          const { name } = languages.find(
            ({ code }) => translation.language_code === code
          )
          translation.name = name
          return translation
        })
      }
      return []
    },
    avaliableLanguages () {
      if (this.template && this.template.translations) {
        return languages.filter(
          e =>
            !this.template.translations.some(
              ({ language_code }) => language_code === e.code
            )
        )
      }
      return languages
    },
    translationSelected () {
      if (this.translationSelectedId) {
        return this.template.translations.find(
          e => e.id === this.translationSelectedId
        )
      }
      return false
    },
    title () {
      if (this.editorMode === 'create') {
        return this.$t('templates.create.title')
      }
      if (this.editorMode === 'edit') {
        return this.$t('templates.edit.title')
      }
      return this.$t('templates.detail.title')
    },
    alert () {
      if (!this.translationSelected) {
        return {
          color: 'error lighten-4',
          icon: 'error',
          iconColor: 'error',
          class: 'error--text',
          text: 'Plantilla sin traducción por defecto'
        }
      }
      if (!this.translationSelected.template) {
        return {
          color: 'orange lighten-4',
          icon: 'warning',
          iconColor: 'warning',
          class: 'warning--text',
          text: this.$t('templates.detail.empty_design')
        }
      }
      return {
        color: 'blue lighten-4',
        icon: 'info',
        iconColor: 'info',
        class: 'info--text',
        text: this.$t('templates.preview_not_available')
      }
    }
  },
  watch: {
    async isOpenTemplateEditor (newVal) {
      if (newVal && this.editorMode === 'edit') {
        await this.setEditData()
      }
      if (!newVal) {
        this.cleanData()
      }
    },
    async template (newVal) {
      this.setDefaultTranslationTemplate()
      if (this.editorMode === 'edit') {
        await this.setEditData()
      }
    },
    'template.translations': function (newVal) {
      this.setDefaultTranslationTemplate()
    }
  },
  async created () {
    this.payload.version = this.editorVersion
  },
  methods: {
    ...mapActions({
      getTemplate: 'templates/getTemplate',
      saveTemplate: 'templates/saveTemplate',
      updateTemplate: 'templates/updateTemplate',
      saveTranslation: 'templates/saveTranslation',
      removeTranslation: 'templates/removeTranslation',
      setDefaultTranslation: 'templates/setDefaultTranslation',
      downloadTemplate: 'templates/downloadTemplate'
    }),
    ...mapMutations({
      setTemplate: 'templates/setTemplate',
      setTranslation: 'templates/setTranslation',
      toggleTemplateTranslations: 'templates/toggleTemplateTranslations',
      openTemplateEditor: 'templates/openTemplateEditor',
      closeTemplateEditor: 'templates/closeTemplateEditor',
      openTemplateDesignEditor: 'templates/openTemplateDesignEditor'
    }),
    handlerInput (arg) {
      if (!arg) {
        this.close()
      }
    },
    async typeChange (type) {
      this.payload.template_event_id = null
      await this.getEvents({ type })
    },
    async openTemplateTranslation () {
      if (this.editorMode === 'create') {
        await this.submitData()
      }
      this.toggleTemplateTranslations(true)
    },
    async openDesignEditor () {
      if (this.editorMode === 'create') {
        const isValid = await this.submitData()
        if (!isValid) {
          return
        }
        this.createTranslationDialog.display = true
      } else if (this.translations.length) {
        this.openTemplateDesign(this.translations[0])
      } else {
        this.createTranslationDialog.display = true
      }
    },
    async submitData () {
      this.submitLoading = true
      const { payload, isGallery, isLayout } = this
      const isValid = await this.$validator.validateAll()
      let res
      if (!isValid) {
        this.submitLoading = false
        return false
      }
      if (this.editorMode === 'create') {
        res = await this.saveTemplate({
          ...payload,
          is_gallery: !isGallery && !isLayout ? true : isGallery,
          is_layout: isLayout
        })
      } else {
        res = await this.updateTemplate(payload)
      }
      if (res.success && this.editorMode === 'create') {
        this.openTemplateEditor({ mode: 'edit' })
      }
      this.submitLoading = false
      return res.success
    },
    async setEditData () {
      this.payload = { ...this.template }
      await this.getEvents({ type: this.payload.type })
    },
    setDefaultTranslationTemplate () {
      const translation = this.template.translations.find(e => e.is_default)
      if (translation) {
        this.translationSelectedId = translation.id
      }
    },
    close () {
      this.closeTemplateEditor()
      this.cleanData()
    },
    cleanData () {
      this.setTemplate({ translations: [] })
      this.downloadLoading = false
      this.submitLoading = false
      this.translationSelectedId = null
      this.payload = {
        type: null,
        template_event_id: null,
        name: '',
        description: '',
        json_config: null,
        template: '',
        status: 'active'
      }
      this.$validator.reset()
    },
    async submitCreateTranslation () {
      const { language_code } = this.createTranslationDialog
      const isValid = await this.$validator.validateAll()
      if (!isValid) {
        return
      }
      this.createTranslationDialog.loading = true
      const { success } = await this.saveTranslation({
        template_id: this.template.id,
        language_code
      })
      if (success) {
        this.closeCreateTranslationDialog()
        this.openTemplateDesignEditor()
      } else {
        this.createTranslationDialog.loading = false
      }
    },
    async openCreateTranslationDialog () {
      if (this.editorMode === 'create') {
        const isValid = await this.submitData()
        if (!isValid) {
          return
        }
      }
      this.createTranslationDialog.display = true
    },
    closeCreateTranslationDialog () {
      this.createTranslationDialog.display = false
      this.createTranslationDialog.loading = false
      this.createTranslationDialog.language_code = null
      this.$validator.reset()
    },
    async submitRemoveTranslation () {
      const { translation_id } = this.removeTranslationDialog
      this.removeTranslationDialog.loading = true
      const { success } = await this.removeTranslation({
        template_id: this.template.id,
        translation_id
      })
      if (success) {
        this.closeRemoveTranslationDialog()
      } else {
        this.removeTranslationDialog.loading = false
      }
    },
    openRemoveTranslationDialog (translation_id) {
      this.removeTranslationDialog.translation_id = translation_id
      this.removeTranslationDialog.display = true
    },
    closeRemoveTranslationDialog () {
      this.removeTranslationDialog.display = false
      this.removeTranslationDialog.loading = false
      this.removeTranslationDialog.translation_id = null
    },
    openTemplateDesign (translation) {
      this.setTranslation(translation)
      this.openTemplateDesignEditor()
    },
    async getPDF () {
      this.downloadLoading = true
      const res = await this.downloadTemplate({
        template_id: this.payload.id
      })
      if (res) {
        this.downloadPDF(res)
      }
      this.downloadLoading = false
    },
    downloadPDF (pdf) {
      const url = window.URL.createObjectURL(
        new Blob([pdf], { type: 'application/pdf' })
      )
      const link = document.createElement('a')
      link.href = url
      link.download = `${this.payload.name}.pdf`
      link.click()
      link.remove()
    }
  }
}
</script>
